import { API_END_POINTS } from "../../constant/config";
import Filter from "../../utils/Filter";
import JsonInterceptor from "../../utils/JsonInterceptor";
import { GET_WIX, CREATE_WIX, GET_SINGLE_WIX, UPDATE_WIX, DELETE_WIX } from "../type"

// Fetch Wix pricing
export const fetchWixDataPricing = (query) => async (dispatch) => {
    try {
        const apiEndpoint = `${API_END_POINTS.FETCH_WIX_WITH_PAGINATION}`;
        let url = `${apiEndpoint}`;
        (query.pageNumber && query.pageNumber != null) && (url += `?page=${query.pageNumber}`);
        (query.pageSize && query.pageSize != null) && (url += `&limit=${query.pageSize}`);
        (query.search && query.search != null) && (url += `&search=${query.search}`);

        const response = await JsonInterceptor.get(url)
        const filter = new Filter();
        filter.baseFilter(response.data.data.docs, query);

        dispatch({
            type: GET_WIX,
            payload: response.data.data,
        });
    } catch (error) {
        console.log("error", error);
    }
};

// Create Wix-Priccing
export const createWixPricing = (data) => async (dispatch) => {

    const updated_price_data = {
        ...data,
    }

    updated_price_data.plan_price = parseFloat(data.plan_price).toFixed(2);

    try {
        const apiEndpoint = API_END_POINTS.CREATE_WIX;
        const response = await JsonInterceptor.post(`${apiEndpoint}`, updated_price_data)
        return dispatch({
            type: CREATE_WIX,
            payload: response.data,
        });
    } catch (error) {
        if (error.response) {
            return dispatch({
                type: CREATE_WIX,
                payload: error.response.data,
            });
        }
    }
};

// Get Single Wix pricing
export const fetchSingleWix = (id) => async (dispatch) => {
    try {
        const apiEndpoint = API_END_POINTS.FETCH_SINGLE_WIX;
        const response = await JsonInterceptor.get(`${apiEndpoint}/${id}`,)
        dispatch({
            type: GET_SINGLE_WIX,
            payload: response.data.data,
        });
    } catch (error) {
        console.log("error", error);
    }
};

// Update Wix pricing
export const updateWixPricing = (data, id) => async (dispatch) => {

    const updated_price_data = {
        ...data,
    }

    updated_price_data.plan_price = parseFloat(data.plan_price).toFixed(2);

    try {
        const apiEndpoint = API_END_POINTS.UPDATE_WIX;
        const response = await JsonInterceptor.put(`${apiEndpoint}/${id}`, updated_price_data)
        return dispatch({
            type: UPDATE_WIX,
            payload: response.data,
        });
    } catch (error) {
        if (error.response) {
            return dispatch({
                type: UPDATE_WIX,
                payload: error.response.data,
            });
        }
    }
};

// Delete Wix Pricing
export const deleteWixPricing = (id) => async (dispatch) => {
    try {
        const apiEndpoint = API_END_POINTS.DELETE_WIX;
        const response = await JsonInterceptor.delete(`${apiEndpoint}/${id}`)
        return dispatch({
            type: DELETE_WIX,
        });
    } catch (error) {
        console.log("error", error);
    }
};